import '@fortawesome/fontawesome-free/css/all.min.css';
import '@govbr/dsgov/dist/dsgov.css';
import axios from 'axios';
import { Route, HashRouter as Router, Switch, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from './app/hooks';
import './assets/cdn-package/fonts/rawline/css/rawline.css';
import auth from './auth/Auth';
import ProtectedRoute from './auth/ProtectedRoute';
import LoadingGlobal from './components/LoadingGlobal/LoadingGlobal';
import config from './envConfig';
import { limpar } from './features/AtualizacaoCadastralPorConfirmacao/atualizacaoCadastralSlice';
import ExtratoBeneficios from './features/Beneficios/ExtratoBeneficios';
import ExtratoConsignadoAuxilioBrasil from './features/Beneficios/ExtratoConsignadoAuxilioBrasil';
import PainelBeneficios from './features/Beneficios/PainelBeneficios';
import CaixaMensagem from './features/CaixaMensagem/CaixaMensagem';
import CaixaMensagemDetalhe from './features/CaixaMensagemDetalhe/CaixaMensagemDetalhe';
import ComoAtualizar from './features/ComoAtualizar/ComoAtualizar';
import ComoCadastrar from './features/ComoCadastrar/ComoCadastrar';
import Comprovante from './features/Comprovante/Comprovante';
import ConsultaCompleta from './features/ConsultaCompleta/ConsultaCompleta';
import ConsultaCpf from './features/ConsultaCpf/ConsultaCpf';
import ConsultaRenda from './features/ConsultaRenda/ConsultaRenda';
import Renda from './features/ConsultaRenda/Renda';
import TutorialConsultaRenda from './features/ConsultaRenda/TutorialConsultaRenda/TutorialConsultaRenda';
import { limpar as limparConsultaRenda } from './features/ConsultaRenda/consultaRendaSlice';
import ConsultaSimples from './features/ConsultaSimples/ConsultaSimples';
import ExclusaoCadastralComposicaoFamiliar from './features/ExclusaoCadastral/ComposicaoFamiliar/ComposicaoFamiliar';
import PainelExclusaoCadastral from './features/ExclusaoCadastral/PainelExclusaoCadastral';
import TutorialExcluirCadastro from './features/ExclusaoCadastral/TutorialExcluirCadastro/TutorialExcluirCadastro';
import Home from './features/Home/Home';
import Informativo from './features/Informativo/Informativo';
import Logout from './features/Logout/Logout';
import LogoutWso2 from './features/Logout/LogoutWso2';
import Perfil from './features/Perfil/Perfil';
import SelecionarPerfil from './features/Perfil/components/SelecionarPerfil/SelecionarPerfil';
import PostoAtendimento from './features/PostoAtendimento/PostoAtendimento';
import ConsultaIntegrantePreCadastro from './features/PreCadastro/ConsultaIntegrantesPreCadastro/ConsultaIntegrantePreCadastro';
import PainelPreCadastro from './features/PreCadastro/PainelPreCadastro';
import PainelUFCriseRS from './features/PreCadastro/PainelUFCriseRS';
import PreCadastroContatos from './features/PreCadastro/components/PreCadastroContatos/PreCadastroContatos';
import PreCadastroEndereco from './features/PreCadastro/components/PreCadastroEndereco/PreCadastroEndereco';
import PreCadastroIntegrante from './features/PreCadastro/components/PreCadastroIntegrante/PreCadastroIntegrante';
import ProgramasSociais from './features/ProgramasSociais/ProgramasSociais';
import TermoDeUso from './features/TermoDeUso/TermoDeUso';
import TutorialPreCadastro from './features/TutorialPreCadastro/TutorialPreCadastro';
import ValidacaoComprovante from './features/ValidacaoComprovante/ValidacaoComprovante';
import { selectLoggingOut, setLoggingIn } from './globalSlice';
import { registerOnMessage } from './platformImpl/cordova/pushLib';
import ScrollToTop from './util/ScrollToTop';
import ConsultaPendencias from './features/ConsultaPendencias/ConsultaPendencias';
import ConsultaEscolaridade from './features/ConsultaEscolaridade/ConsultaEscolaridade';
import TutorialConsultaEscolaridade from './features/ConsultaEscolaridade/TutorialConsultaEscolaridade/TutorialConsultaEscolaridade';
import ExclusaoPorObito from './features/ExclusaoPorObito/ExclusaoPorObito';
import TutorialExclusaoPorObito from './features/ExclusaoPorObito/TutorialExclusaoPorObito/TutorialExclusaoPorObito';
import SuccessLogin from './auth/SuccessLogin';
import { loginGateway, limparAuth } from './auth/authSlice';
import { limparDadosFamilia } from './features/ConsultaSimples/consultaSimplesSlice';
import { limparPerfil } from './features/Perfil/perfilSlice';

function App() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const loggingOut = useAppSelector(selectLoggingOut);

  dispatch(limpar());
  dispatch(limparConsultaRenda())

  const resetHeight = () => {
    // reset the body height to that of the inner browser
    document.body.style.height = window.innerHeight + 'px';
  };
  // reset the height whenever the window's resized
  window.addEventListener('resize', resetHeight);
  // called to initially set the height.
  resetHeight();

   function onDeviceReady() {
     //@ts-expect-error
      window.open = cordova.InAppBrowser.open;
      let callback = (payload, type) => { };
      registerOnMessage(callback);
  }
  if (config.isCordova) {
    document.addEventListener("deviceready", onDeviceReady, false);
  }

const handleLogout = (history, dispatch) => {
  //auth.logoutGovBr();
  sessionStorage.removeItem('gateway-logado');
  sessionStorage.removeItem('isLoggedIn');
  localStorage.removeItem('isLoggedInClosed');
  sessionStorage.removeItem('user');
  auth.login();
};

const handleLogoutTokenExpirado = (history, dispatch) => {
  //auth.logoutGovBr();
  sessionStorage.removeItem('gateway-logado');
  sessionStorage.removeItem('isLoggedIn');
  localStorage.removeItem('isLoggedInClosed');
  sessionStorage.removeItem('user');
  //auth.tratarTokenExpirado();
  dispatch(limparPerfil());
  dispatch(limparDadosFamilia());
  //dispatch(loginGateway(restOfProps.path));
  dispatch(setLoggingIn(false));
  dispatch(limparAuth());
  auth.limparStorage();
  window.location.replace("#/home")
  window.location.reload();
};

axios.interceptors.response.use(
  (response) => {
    if (response.headers['content-type']?.includes('text/html')) {
      alert("Sua sessão expirou. Por favor, efetue login novamente para continuar.");
      handleLogout(history, dispatch);
    }

    return response;
  },
  (error) => {
    const res = error.response;

    if (res?.status === 401 && res?.config?.baseURL === config.urlApi) {
      alert("Sessão expirada. Por favor, efetue login novamente para continuar.");
      handleLogoutTokenExpirado(history, dispatch);
    }

    return Promise.reject(error);
  }
);

  if (loggingOut) {
    return <LoadingGlobal />;
  }

  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <ProtectedRoute exact path="/home" component={Home} isHome />
        <Route exact path="/successLogin" component={SuccessLogin}/>

        <Route exact path="/" component={Informativo} />
        <Route exact path="/logoutWso2" component={LogoutWso2} />
        <Route exact path="/logout" component={Logout} />
        {/* <Route exact path="/identificacao-positiva" component={IdentificacaoPositiva} /> */}
        <Route exact path="/termo-de-uso" component={TermoDeUso} />
        <Route exact path="/validacao-comprovante" component={ValidacaoComprovante} />
        <Route exact path="/posto-atendimento" component={PostoAtendimento} />
        <Route exact path="/programas-sociais" component={ProgramasSociais} />
        <Route exact path="/como-cadastrar" component={ComoCadastrar} />
        <Route exact path="/como-atualizar" component={ComoAtualizar} />
        <Route exact path="/tutorial-pre-cadastro" component={TutorialPreCadastro} />
        <Route exact path="/consultaCpf" component={ConsultaCpf} />

        <ProtectedRoute exact path="/consultaSimples" component={ConsultaSimples} govBrOnly />
        <ProtectedRoute exact path="/comprovante" component={Comprovante} govBrOnly />
        <ProtectedRoute exact path="/perfil" component={Perfil} govBrOnly />
        <ProtectedRoute exact path="/selecionarPerfil" component={SelecionarPerfil} govBrOnly />
        <ProtectedRoute exact path="/caixa-mensagem" component={CaixaMensagem} govBrOnly />
        <ProtectedRoute exact path="/caixa-mensagem-detalhe" component={CaixaMensagemDetalhe} govBrOnly />

        <ProtectedRoute exact path="/consultaCompleta" component={ConsultaCompleta} govBrOnly />

        {/* <ProtectedRoute exact path="/atualizacaoCadastralPorConfirmacao" component={PainelAtualizacaoCadastral} govBrOnly />
        <ProtectedRoute exact path="/atualizacaoCadastralPorConfirmacao/endereco" component={Endereco} govBrOnly />
        <ProtectedRoute exact path="/atualizacaoCadastralPorConfirmacao/contato" component={Contato} govBrOnly />
        <ProtectedRoute exact path="/atualizacaoCadastralPorConfirmacao/composicaoFamiliar" component={ComposicaoFamiliar} govBrOnly />
        <ProtectedRoute exact path="/atualizacaoCadastralPorConfirmacao/integranteFamiliar" component={Integrante} govBrOnly /> */}

        <ProtectedRoute exact path="/painelBeneficios" component={PainelBeneficios} govBrOnly />
        <ProtectedRoute exact path="/extratoBeneficios" component={ExtratoBeneficios} govBrOnly />
        <ProtectedRoute exact path="/extratoConsignado" component={ExtratoConsignadoAuxilioBrasil} govBrOnly />

       {/* <ProtectedRoute exact path="/preCadastro" component={PainelPreCadastro} govBrOnly />
        <ProtectedRoute exact path="/selecaoUFCriseRS" component={PainelUFCriseRS} govBrOnly />

        <ProtectedRoute exact path="/preCadastro/integrante" component={PreCadastroIntegrante} govBrOnly />
        <ProtectedRoute exact path="/preCadastro/contatos" component={PreCadastroContatos} govBrOnly />
        <ProtectedRoute exact path="/preCadastro/endereco" component={PreCadastroEndereco} govBrOnly />
        <ProtectedRoute exact path="/preCadastro/consultaIntegrante" component={ConsultaIntegrantePreCadastro} govBrOnly />*/}

        <ProtectedRoute exact path="/consultaRenda" component={ConsultaRenda} govBrOnly />
        <Route exact path="/consultaRenda/tutorial" component={TutorialConsultaRenda} />
        <ProtectedRoute exact path="/renda" component={Renda} govBrOnly />
        {/*<ProtectedRoute exact path="/rendaCadastroUnico" component={RendaCadastroUnico} govBrOnly />*/}

        <ProtectedRoute exact path="/exclusaoCadastral" component={PainelExclusaoCadastral} govBrOnly />
        <ProtectedRoute exact path="/exclusaoCadastral/composicaoFamiliar" component={ExclusaoCadastralComposicaoFamiliar} govBrOnly />
        <Route exact path="/exclusaoCadastral/tutorial" component={TutorialExcluirCadastro}  />
        <ProtectedRoute exact path="/exclusaoPorObito" component={ExclusaoPorObito} govBrOnly />
        <Route exact path="/exclusaoPorObito/tutorial" component={TutorialExclusaoPorObito} />

        <ProtectedRoute exact path="/consulta-pendencias" component={ConsultaPendencias} govBrOnly />

        <ProtectedRoute exact path="/consultaEscolaridade" component={ConsultaEscolaridade} govBrOnly />
        <Route exact path="/consultaEscolaridade/tutorial" component={TutorialConsultaEscolaridade} />

      </Switch>
    </Router>
  );
}

export default App;
